import ajax from "./request.js";
import store from "@/store";

let bool = process.env.NODE_ENV === "production";
const href = bool
  ? `https://${window.location.host}/api/cloud/license`
  : "/api/cloud/license";

function splitCsv(v) {
  if (!v || !String(v).trim()) {
    return [];
  }
  return String(v)
    .split(/[,，\n]/)
    .map((s) => s.trim())
    .filter(Boolean);
}

function generateLocalLicense(form) {
  const data = {
    description: form.description,
    issued_time: form.issued_time,
    expiry_time: form.expiry_time,
    license_check_model: {
      ip_address: splitCsv(form.ip_addr),
      mac_address: splitCsv(form.mac),
      sn_address: splitCsv(form.sn),
      cpu_serial: form.cpu_serial || "",
      main_board_serial: form.main_board_serial || "",
      level: form.level,
    },
  };
  const token = (store.state && store.state.loginAccountInfo && store.state.loginAccountInfo.token) || "";
  return new Promise((resolve, reject) => {
    const ajaxXhr = new XMLHttpRequest();
    ajaxXhr.responseType = "blob";
    ajaxXhr.open("POST", `${href}/generateLicenseRsa`);
    ajaxXhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    if (token) {
      ajaxXhr.setRequestHeader("token", token);
    }
    ajaxXhr.onload = function () {
      const blob = ajaxXhr.response;
      const type = (blob && blob.type) || "";
      if (type.indexOf("application/json") > -1) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            resolve(JSON.parse(reader.result));
          } catch (e) {
            reject(e);
          }
        };
        reader.readAsText(blob);
        return;
      }
      if (ajaxXhr.status >= 200 && ajaxXhr.status < 300) {
        let filename = "license.lic";
        const dispo = ajaxXhr.getResponseHeader("Content-Disposition") || "";
        const m = dispo.match(/filename\*?=(?:UTF-8'')?([^;]+)/i) || dispo.match(/filename=([^;]+)/i);
        if (m && m[1]) {
          filename = decodeURIComponent(m[1].replace(/"/g, "").trim());
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        resolve({ status: "success" });
        return;
      }
      reject(new Error("下载失败"));
    };
    ajaxXhr.onerror = () => reject(new Error("下载失败"));
    ajaxXhr.send(JSON.stringify(data));
  });
}

function queryLicenseGenerateHistory(data) {
  return ajax(`${href}/queryGenerateHistory`, {
    method: "POST",
    data,
  });
}

function generateHubLicense(form) {
  const data = {
    description: form.description,
    issued_time: form.issued_time,
    expiry_time: form.expiry_time,
    license_check_model: {
      deploy_mode: form.deploy_mode || "standalone",
      ip_address: splitCsv(form.ip_addr),
      mac_address: splitCsv(form.mac),
      sn_address: splitCsv(form.sn),
      features: form.features || [],
    },
  };
  const token = (store.state && store.state.loginAccountInfo && store.state.loginAccountInfo.token) || "";
  return new Promise((resolve, reject) => {
    const ajaxXhr = new XMLHttpRequest();
    ajaxXhr.responseType = "blob";
    ajaxXhr.open("POST", `${href}/generateHubLicense`);
    ajaxXhr.setRequestHeader("Content-Type", "application/json;charset=utf-8");
    if (token) {
      ajaxXhr.setRequestHeader("token", token);
    }
    ajaxXhr.onload = function () {
      const blob = ajaxXhr.response;
      const type = (blob && blob.type) || "";
      if (type.indexOf("application/json") > -1) {
        const reader = new FileReader();
        reader.onload = () => {
          try {
            resolve(JSON.parse(reader.result));
          } catch (e) {
            reject(e);
          }
        };
        reader.readAsText(blob);
        return;
      }
      if (ajaxXhr.status >= 200 && ajaxXhr.status < 300) {
        let filename = "wirdhouse_license.lic";
        const dispo = ajaxXhr.getResponseHeader("Content-Disposition") || "";
        const m = dispo.match(/filename\*?=(?:UTF-8'')?([^;]+)/i) || dispo.match(/filename=([^;]+)/i);
        if (m && m[1]) {
          filename = decodeURIComponent(m[1].replace(/"/g, "").trim());
        }
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        resolve({ status: "success" });
        return;
      }
      reject(new Error("下载失败"));
    };
    ajaxXhr.onerror = () => reject(new Error("下载失败"));
    ajaxXhr.send(JSON.stringify(data));
  });
}

export default { generateLocalLicense, queryLicenseGenerateHistory, generateHubLicense };
